$(document).ready(function () {

  // Barre d'annonce
  // --------------------------------------------
  // Click sur le bouton de fermeture de la barre
  $('.close_announcement_bar').click(function (e) {
    e.preventDefault();
    $(this).remove();

    // Transition de fermeture
    $('.announcement-bar-section').slideUp(150, function () {
      $(this).remove();
    })

    // On stocke en session la demande de fermeture
    sessionStorage.setItem("closed_announcement", "true");
  });

  // Megamenu au survol
  $(".header__inline-menu details").hover(function (e) {
    $(this).attr("open", true);
    $(this).find(".header__submenu").mouseleave(function (e) {
      $(this).parent().removeAttr("open");
    });
  }, function (e) {
    $(this).attr("open", false);
  });

  // Ouverture onglets menu mobile
  // --------------------------------------------
  $(".menu-drawer__menu-item").on('click', function () {
    $(this).toggleClass("active");
  });

  // Footer
  // --------------------------------------------
  $(".footer-block__heading").on('click', function () {
    $(this).toggleClass("active");
  });

  // Redirections
  // --------------------------------------------
  if ($(".image-block").length) {
    $(document).on('click', '.image-block', function () {
      var redirect = $(this).data("target");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  // Redirection sur les images de la page d'accueil
  // --------------------------------------------
  if ($(".pointer").length) {
    $(document).on('click', '.pointer', function () {
      var redirect = $(this).find("a").attr("href");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  // Sections administrables
  // --------------------------------------------
  if ($(".section-storytelling").length) {
    $(".tabs h3").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).next("div").hide();
      } else {
        $(".tabs h3").removeClass("active");
        $(".tabs h3").next("div").hide();
        $(this).addClass("active");
        $(this).next("div").show();
      }
    });
  }

  // PDP
  // --------------------------------------------
  // Fermeture guide des tailles
  $(document).on('click', '#sizing .close, #sizing', function () {
    $("#sizing, .overlay").fadeOut();
    $("#sizing, .overlay").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  // Ouverture guide des tailles
  $(document).on('click', '.sizing_btn', function () {
    $("#sizing, .overlay").fadeIn();
    $("#sizing, .overlay").addClass("active");
    $("body").addClass("overflow-hidden");
  });

  // Fermeture disponibilité
  $(document).on('click', '#drawer_disponibilite.drawer .drawer_close, #drawer_disponibilite.drawer', function () {
    $("#drawer_disponibilite.drawer").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  $(document).on('click', '.shop_availability', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").addClass("active");
  });

   $(document).on('click', '#sizing_content, .drawer_wrapper_inner', function (event) {
    event.stopPropagation();
  });

  // Ouverture onglets boutique
  $(document).on('click', '.boutique_header', function () {
    $(this).next("div").toggle();
  });

  $(".content_2 a").hover(function (e) {
    $(this).parent("p").siblings("p").find("a").css("color", "#999");
  }, function (e) {
    $(this).parent("p").siblings("p").find("a").css("color", "#000");
  });

  //swiper mobile
  if ($(".product_page_section .product_swiper").length && $(window).width() < 990) {
    var $swiperContainer = $(".product_page_section .product_swiper");
    var slideCount = $swiperContainer.find(".swiper-slide").length;

    if (slideCount === 1) {
      $swiperContainer.addClass("single-slide");
    }

    new Swiper(".product_page_section .product_swiper", {
      loop: slideCount > 1,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
    });
  }

  if ($("quick-add-modal .product_page_section .product_swiper").length && $(window).width() > 990) {
    var $swiperContainer = $("quick-add-modal .product_page_section .product_swiper");
    var slideCount = $swiperContainer.find(".swiper-slide").length;

    if (slideCount === 1) {
      $swiperContainer.addClass("single-slide");
    }

    new Swiper("quick-add-modal .product_page_section .product_swiper", {
      loop: slideCount > 1,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
    });
  }

  // guide des tailles
  if ($('#sizing').length) {
    // Au clic sur le span de class "in"
    $('span.in').on('click', function () {
      if (!$('span.in').hasClass('selected')) {
        $('span.in').addClass('selected');
        $('span.cm').removeClass('selected');
      }
      if (!$('table.in').hasClass('opened')) {
        $('table.in').addClass('opened');
        $('table.cm').removeClass('opened');
      }
    });

    // Au clic sur le span de class "cm"
    $('span.cm').on('click', function () {
      if (!$('span.cm').hasClass('selected')) {
        $('span.cm').addClass('selected');
        $('span.in').removeClass('selected');
      }
      if (!$('table.cm').hasClass('opened')) {
        $('table.cm').addClass('opened');
        $('table.in').removeClass('opened');
      }
    });
  }

  // Custom product form activation
  if ($("#custom_product_widget").length) {

    $("#custom_activated").removeAttr("checked");

    $("#custom_activated").on("change", function () {
      if ($("#custom_activated").is(":checked")) {
        $("body").addClass("overflow-hidden");
        $("#custom_product_widget .custom_fields, #custom_product_widget .custom_container, #custom_product_widget .custom_text").fadeIn();
        $(".custom_product_field").removeAttr('disabled').attr('required', 'required');
        $(".custom_fields input.field__input").trigger("keyup");
        $(".custom_fields select.select__select").trigger("change");
      } else {
        $("body").removeClass("overflow-hidden");
        $("#custom_product_widget .custom_fields, #custom_product_widget .custom_container, #custom_product_widget .custom_text").fadeOut();
        $(".custom_product_field").attr('disabled', 'disabled').removeAttr('required');
      }
    });

    $(".custom_product_field").on("click", function () {
      var value = $(this).val();
      $(this).siblings(".hidden_input").val(value);
    });

    $(".text_input").on("keyup", function () {
      var value = $(this).val();
      $(this).next().val(value);
    });

    $("#add_custom_product").on("click", function () {
      // cleaner le formulaire
      $(".error").hide();
      $(".custom_fields .required").removeClass("required");

      // revalider les champs
      $(".color_select:required").each(function () {
        if ($(this).val() == "") {
          $(this).parents("variant-selects").addClass("required");
        }
      });

      // Après la validation, on envoie le formulaire s'il n'y a plus d'erreurs (class error ou required ici)
      if (!$(".custom_fields .required").length) {
        $("#custom_product_widget .custom_fields").fadeOut();
        $(".product-form__submit").click();
        $(".text_input").val("");
      } else {
        $(".error").show();
      }
    });

    $(".icon-close").on("click", function () {
      $("#custom_product_widget .custom_fields").fadeOut();
      $(".custom_fields .required").removeClass("required");
      $(".error").hide();
      $(".custom_product_field").val("");
      $("#custom_activated").prop("checked", false).trigger("change");
    });
  }

  // Switch cross
  $(document).on("click", "nav.cross_nav span", function (event) {
    var $name = $(this).data("name");
    $("nav.cross_nav span").removeClass("selected");
    $(this).addClass("selected");
    $(".cross_content > *").hide();
    $(".cross_content > #" + $name).css("display", "block");
  });

  // Accordon contenus FAQ
  $(document).on("click", "h3.question", function () {
    var title = $(".h3.question");
    var content = $(".response");
    $(this).toggleClass("active");
    if (content.length) {
      $(title).not($(this)).removeClass("active");
      $(title).not($(this)).next(content).slideUp();
      $(this).next(content).slideToggle();
    }
  });

  const add_to_cart_buttons = $('.product-form__buttons');
  const sticky_basket = $('#shopify-section-sticky_basket');


  $(document).scroll(function () {

    if ($(window).width() < 990) {
      if (add_to_cart_buttons.length === 0) {
        return;
      }

      const isVisible = isInViewport(add_to_cart_buttons);

      if (isVisible) {
        sticky_basket.slideUp(200);
      }
      else {
        sticky_basket.slideDown(200);
      }
    }
  });

  // Sticky button sur fiche produit
  $("#sticky_basket").click(function () {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".product__info-wrapper").offset().top
    }, 400);
  })

  $("#sticky_basket .bis_trigger").click(function () {
    $(".klaviyo-bis-trigger").click();
  })

  // PLP
  // ------------------------------------------------

  // filters
  $(document).on("click", ".mobile-facets__summary", function () {
    $(this).toggleClass("active");
    $(this).next().toggle();
  });

   // Load more
  $(document).on("click", ".js-load-more", function () {
    var $this = $(this),
    totalPages = parseInt($("[data-total-pages]").val()),
    currentPage = parseInt($("[data-current-page]").val());

    $this.attr("disabled", true);
    $this.find("[load-more-text]").addClass("hide");
    $this.find("[loader]").removeClass("hide");

    currentPage = currentPage + 1;

    var nextUrl = $("[data-next-url]")
      .val()
      .replace(/page=[0-9]+/, "page=" + currentPage);

    $("[data-current-page]").val(currentPage);

    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        var $response = $(responseHTML);

        // Ajouter les nouveaux produits
      $(".collection-grid-plp").append($response.find(".collection-grid-plp").html());

      // Mettre à jour la pagination
      $(".pagination_count").html($response.find(".pagination_count").html());

      var newNextUrl = $response.find("[data-next-url]").val();
      if (newNextUrl) {
        $("[data-next-url]").val(newNextUrl);
      }
      },
      complete: function () {
        if (currentPage <= totalPages) {
          $this.attr("disabled", false);
          $this.find("[load-more-text]").removeClass("hide");
          $this.find("[loader]").addClass("hide");
        }
        if (currentPage == totalPages) {
          $this.hide();
        }
      },
    });
  });

  initSwipers();

  // Cart drawer
  // ----------------------------------------------------------------------------
  // Switch onglets section détails produit
  $(document).on("click", ".drawer__upsell .icon-close", function (event) {
    console.log("click");
    $(".drawer__upsell").slideUp();
  });

});

// Réinitialise les functions appliquées à la card product après un changement dans le DOM
var observeDOM = (function () {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      // define a new observer
      var mutationObserver = new MutationObserver(callback);

      // have the observer observe for changes in children
      mutationObserver.observe(obj, { childList: true, subtree: false });
      return mutationObserver;
    }

    // browser support fallback
    else if (window.addEventListener) {
      obj.addEventListener("DOMNodeInserted", callback, false);
      obj.addEventListener("DOMNodeRemoved", callback, false);
    }
  };
})();

// Réinitialise les functions appliquées à la card product après un changement dans le DOM
observeDOM(document.getElementById("product-grid"), function (m) {
  initSwipers()
  initSwipersLazy();
});

function initSwipers() {
  var $target = $(".mySwiper").not(".swiper-initialized, .swiper_disabled");
  if ($target.length) {
    // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
    $target.each(function () {
      var $swiperEl = $(this);
      var $slides = $swiperEl.find(".swiper-slide");
      if ($slides.length <= 1) {
        // Si une seule slide, on masque les contrôles manuellement
        $swiperEl.addClass("single-slide");
      } else {
        // Sinon, on initialise le swiper normalement
        new Swiper($swiperEl.get(0), {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
          },
          breakpoints:{
            0: {
              allowTouchMove: true,
            },
            789: {
              allowTouchMove: true,
            },
          }
        });
      }
    });
  }
}

function initSwipersLazy() {
  var $target = $(".mySwiper").not(".swiper-initialized, .swiper_disabled");
  if ($target.length) {
    // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
    $target.each(function () {
      var $swiperEl = $(this);
      var $slides = $swiperEl.find(".swiper-slide");
      if ($slides.length <= 1) {
        // Si une seule slide, on masque les contrôles manuellement
        $swiperEl.addClass("single-slide");
      } else {
        // Sinon, on initialise le swiper normalement
        new Swiper($swiperEl.get(0), {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
          },
          breakpoints:{
            0: {
              allowTouchMove: true,
            },
            789: {
              allowTouchMove: true,
            },
          }
        });
      }
    });
  }
}


function isInViewport(el) {
  if (typeof el.get(0) === 'undefined') {
    return false;
  }

  const rect = el.get(0).getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= ($(window).height() || $(document).height()) &&
    rect.right <= ($(window).width() || $(document).width())
  );
}